import {
	Component,
	EventEmitter,
	Input,
	Output,
	ViewChild,
} from '@angular/core'
import {
	brandListModel,
	categoryListModel,
	promoCodeFilter,
	createPromoCodePayload,
} from '../../models/products.model'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { ProductsService } from '../../services/products.service'
import { SharedService } from 'src/app/shared/services/shared.service'
import { TranslateService } from '@ngx-translate/core'
import { ActivationStatus } from 'src/app/shared/enums/general.enum'
import { Subscription, debounceTime, filter, retry } from 'rxjs'
import { gender } from '../../models/products.enum'
import { MatOption, MatSelect } from '@angular/material/select'
import { productPromoCodeType } from '../../models/product-promo-code.enum'
import {
	promoCodeProductList,
	viewProductPromocodeModel,
} from '../../models/product-promo-code.model'

import { Router } from '@angular/router'
import { ToastrService } from 'ngx-toastr'
import { MatDialog } from '@angular/material/dialog'
import { UploadImageComponent } from 'src/app/shared/components/upload-image/upload-image.component'
import { ImageUpload } from 'src/app/shared/models/general.models'
import { OffersService } from 'src/app/modules/offers/services/offers.service'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-edit-product-promocode',
	templateUrl: './edit-product-promocode.component.html',
	styleUrl: './edit-product-promocode.component.scss',
})
export class EditProductPromocodeComponent {
	@ViewChild('select') select!: MatSelect
	@ViewChild('allSelected') private allSelected!: MatOption
	@Input() promocodeDetails!: viewProductPromocodeModel
	@Input() id: string = ''
	@Output() changeEditMode: EventEmitter<boolean> = new EventEmitter(false)
	promoCodeProductList!: promoCodeProductList[]
	subscription = new Subscription()
	productPromoCodeForm: FormGroup = new FormGroup({})
	promoCodeFilter: promoCodeFilter = {
		countryId: 224,
		brandId: null,
		categoryId: null,
		subCategoryId: null,
		subSubCategoryId: null,
		gender: null,
		startDate: '',
		endDate: '',
		searchText: '',
	}

	promoTypes = this.SharedService.returnEnumArray(productPromoCodeType)
	categoryFilter: any = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		searchText: '',
	}

	today = new Date()
	isActiveEnum = ActivationStatus

	showSubCategory: boolean = false
	showSubSubCategory: boolean = false
	categoryvalue: any
	productValue: any
	subCategory: any
	subSubCategory: any
	categoryList: categoryListModel[] | null = null
	subCategoryList: categoryListModel[] | null = null
	subSubCategoryList: categoryListModel[] | null = null
	brandList: brandListModel[] | null = null
	productsList: brandListModel[] | null = null
	genders: any[] | null = null
	categoryKeyWord = new FormControl('')
	subCategoryKeyWord = new FormControl('')
	subSubCategoryKeyWord = new FormControl('')
	brandKeyWord = new FormControl('')
	productKeyword = new FormControl('')
	selectedBrand!: any
	selectedProduct!: any
	selectedProductNames: any[] = []
	allSelectedFlag: boolean = false
	labelOverlapError: boolean = false
	selectedProductsToDisable!: number[]
	hideProductSearch: boolean = true
	imgConfig: ImageUpload = {
		imageCropDimensions: 2.1,
		imageWidth: 800,
		imageHeight: 500,
	}
	attachmentLink = environment.attachmentPath
	constructor(
		public translate: TranslateService,
		private SharedService: SharedService,
		private ProductsService: ProductsService,
		private router: Router,
		private toaster: ToastrService,
		private dialog: MatDialog,
		private offerService: OffersService
	) {
		this.initForm()
	}
	ngOnInit(): void {
		this.genders = this.SharedService.returnEnumArray(gender)
		this.subscription.add(
			this.categoryKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.getCategoryList(String(this.categoryKeyWord.value))
				})
		)
		this.subscription.add(
			this.subCategoryKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.getSubCategoryList(
						String(this.subCategoryKeyWord.value),
						this.getController('categoryId').value
					)
				})
		)
		this.subscription.add(
			this.subSubCategoryKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.getSubSubCategoryList(
						String(this.subSubCategoryKeyWord.value),
						this.getController('subCategoryId').value
					)
				})
		)
		this.subscription.add(
			this.brandKeyWord.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe(() => {
					this.getBrandList(String(this.brandKeyWord.value))
				})
		)
		this.subscription.add(
			this.productKeyword.valueChanges
				.pipe(
					filter((q: any) => q?.trim().length > 1 || !q?.trim().length),
					debounceTime(700),
					retry(-1)
				)
				.subscribe((res) => {
					this.promoCodeFilter.searchText = res
					this.getFilteredProducts(false)
				})
		)
		this.getCategoryList('', true)
		this.promocodeDetails?.category
			? this.getSubCategoryList(
					'',
					this.promocodeDetails?.category?.id,
					this.promocodeDetails?.subCategory ? true : false
			  )
			: null
		this.promocodeDetails?.subSubCategory
			? this.getSubSubCategoryList(
					'',
					this.promocodeDetails?.subSubCategory?.id,
					this.promocodeDetails?.subSubCategory ? true : false
			  )
			: null
		this.getBrandList('')

		this.getFilteredProducts(true)

		this.initForm()
		this.changePromoCodeType(this.promocodeDetails.promoCodeType)

		this.getController('promocodeAmount')?.patchValue(
			this.promocodeDetails?.promoCodeAmount
		)
		this.checkProductsStartEndDate()
		this.getSelectedProductNames()
		this.promocodeDetails?.partialEdit
			? this.getController('startDate').setErrors(null)
			: null
		this.getController('startDate').setErrors(null)
	}

	ngOnChanges() {
		this.initForm()

		this.promocodeDetails?.partialEdit
			? (this.selectedProductsToDisable = this.promocodeDetails.productName.map(
					(ele: any) => ele.id
			  ))
			: null

		let selectedType = this.promoTypes.filter(
			(ele: any) => ele.value == this.promocodeDetails.promoCodeType
		)
		this.getController('promoCodeType').patchValue(selectedType[0])
	}
	initForm() {
		this.productPromoCodeForm = new FormGroup({
			offerNameAr: new FormControl(
				{
					value: this.promocodeDetails?.offerNameAr,
					disabled: this.promocodeDetails?.partialEdit,
				},
				[Validators.required]
			),
			offerNameEn: new FormControl(
				{
					value: this.promocodeDetails?.offerNameEn,
					disabled: this.promocodeDetails?.partialEdit,
				},
				[Validators.required]
			),
			code: new FormControl(
				{
					value: this.promocodeDetails?.code,
					disabled: this.promocodeDetails?.partialEdit,
				},
				[Validators.required]
			),
			startDate: new FormControl(
				{
					value: this.promocodeDetails?.startDate,
					disabled: this.promocodeDetails?.partialEdit,
				},
				Validators.required
			),
			endDate: new FormControl(this.promocodeDetails?.endDate, [
				Validators.required,
			]),
			clientUsageCount: new FormControl(
				this.promocodeDetails?.clientUsageCount,
				[
					Validators.required,
					this.promocodeDetails?.partialEdit
						? Validators.min(this.promocodeDetails?.clientUsageCount)
						: Validators.min(1),
				]
			),
			maxUsageCount: new FormControl(this.promocodeDetails?.maxUsageCount, [
				Validators.required,
				this.promocodeDetails?.partialEdit
					? Validators.min(this.promocodeDetails?.maxUsageCount)
					: Validators.min(1),
			]),
			isActive: new FormControl(this.promocodeDetails?.isActive, [
				Validators.required,
			]),
			numberOfSameProduct: new FormControl(
				{
					value:
						this.promocodeDetails?.numberOfSameProduct == 0
							? null
							: this.promocodeDetails?.numberOfSameProduct,
					disabled: this.promocodeDetails?.partialEdit,
				},
				Validators.min(1)
			),
			promoCodeType: new FormControl(
				this.promocodeDetails?.promoCodeType || 1,

				[Validators.required]
			),
			promocodeAmount: new FormControl(
				{
					value: this.promocodeDetails?.promoCodeAmount,
					disabled: this.promocodeDetails?.partialEdit,
				},
				[Validators.required, Validators.min(1)]
			),
			fixedDiscountMinimum: new FormControl(
				{
					value: this.promocodeDetails?.fixedDiscountMinimum,
					disabled: this.promocodeDetails?.partialEdit,
				},

				[Validators.min(1)]
			),
			percentageUpto: new FormControl(
				{
					value: this.promocodeDetails?.percentageUpto,
					disabled: this.promocodeDetails?.partialEdit,
				},

				[Validators.min(1)]
			),
			offerBuyCount: new FormControl(
				{
					value: this.promocodeDetails?.offerBuyCount,
					disabled: this.promocodeDetails?.partialEdit,
				},

				[Validators.min(1)]
			),
			offerGetCount: new FormControl(
				{
					value: this.promocodeDetails?.offerGetCount,
					disabled: this.promocodeDetails?.partialEdit,
				},

				[Validators.min(1)]
			),
			countryId: new FormControl(this.promocodeDetails?.countryId, [
				Validators.required,
			]),
			gender: new FormControl(this.promocodeDetails?.gender),
			productVariantIds: new FormControl(this.promocodeDetails?.productName, [
				Validators.required,
			]),
			brandId: new FormControl({
				value: this.promocodeDetails?.brand,
				disabled: this.promocodeDetails?.partialEdit,
			}),
			categoryId: new FormControl({
				value: this.promocodeDetails?.category,
				disabled: this.promocodeDetails?.partialEdit,
			}),
			subCategoryId: new FormControl({
				value: this.promocodeDetails?.subCategory,
				disabled: this.promocodeDetails?.partialEdit,
			}),
			subSubcategoryId: new FormControl({
				value: this.promocodeDetails?.subSubCategory,
				disabled: this.promocodeDetails?.partialEdit,
			}),
			showLabel: new FormControl(this.promocodeDetails?.hasLabel),
			offerImageAr: new FormControl(this.promocodeDetails?.offerImageAr),
			offerImageEn: new FormControl(this.promocodeDetails?.offerImageEn),
		})
	}

	startDateAfterEndDate() {
		if (
			this.getController('endDate').value <
				this.getController('startDate').value &&
			this.getController('endDate').value
		) {
			this.getController('startDate').setErrors({
				endDateGreaterThanStartDate: true,
			})
		} else {
			delete this.getController('startDate').errors?.endDateGreaterThanStartDate
		}
	}
	checkAllSelected(): boolean {
		if (this.allSelected.selected) {
			this.allSelected.deselect()
			this.allSelectedFlag = this.allSelected.selected
			return false
		}

		if (
			this.getController('productVariantIds').value.length ==
			this.promoCodeProductList.length
		) {
			this.allSelected.select()
			this.allSelectedFlag = this.allSelected.selected
			return true
		}

		return false
	}

	toggleAllSelection() {
		if (this.allSelected.selected) {
			this.select.options.forEach((option: MatOption) => {
				option.select()
			})
			this.allSelectedFlag = true
		} else {
			this.promocodeDetails?.partialEdit
				? this.getController('productVariantIds').patchValue(
						this.selectedProductsToDisable
				  )
				: this.getController('productVariantIds').patchValue([])
			this.allSelectedFlag = false
		}
	}

	categorySelectionChange() {
		this.getController('productVariantIds').patchValue([])
	}
	getCategoryList(keyword: string, firstLoad: boolean = false) {
		this.subscription.add(
			this.ProductsService.getCategoryList(keyword, null).subscribe({
				next: (res: any) => {
					this.categoryList = res.result
				},

				complete: () => {
					this.getController('categoryId').setValue(
						this.promocodeDetails?.category?.id
					)
					firstLoad
						? (this.categoryvalue = this.promocodeDetails.category)
						: (this.categoryvalue = null)
					this.promocodeDetails.subCategory
						? this.getSubCategoryList('', this.categoryvalue?.id, firstLoad)
						: null
				},
			})
		)
	}

	getSubCategoryList(
		keyword: string,
		categoryId: Number,
		firstLoad: boolean = false
	) {
		this.subscription.add(
			this.ProductsService.getCategoryList(keyword, categoryId).subscribe({
				next: (res: any) => {
					this.subCategoryList = res?.result
				},
				error: (error: any) => {
					console.error('Error fetching subcategory list', error)
				},
				complete: () => {
					if (firstLoad) {
						this.getController('subCategoryId').setValue(
							this.promocodeDetails?.subCategory?.id
						)

						this.subCategory = this.promocodeDetails.subCategory
						this.promocodeDetails.subSubCategory
							? this.getSubSubCategoryList('', this.subCategory?.id, firstLoad)
							: null
					} else {
						this.getController('subCategoryId').setValue(null)

						this.subCategory = null
						this.promocodeDetails.subSubCategory
							? this.getSubSubCategoryList('', this.subCategory?.id, firstLoad)
							: null
					}
				},
			})
		)
	}

	getSubSubCategoryList(
		keyword: string,
		categoryId: Number,
		firstLoad: boolean = false
	) {
		this.subscription.add(
			this.ProductsService.getCategoryList(keyword, categoryId).subscribe({
				next: (res: any) => {
					this.subSubCategoryList = res?.result
				},
				complete: () => {
					if (firstLoad) {
						this.getController('subSubcategoryId')?.setValue(
							this.promocodeDetails?.subSubCategory?.id
						)

						this.subSubCategory = this.promocodeDetails?.subSubCategory
					} else {
						this.getController('subSubcategoryId')?.setValue(null)

						this.subSubCategory = null
					}
				},
			})
		)
	}

	getBrandList(SearchText: String) {
		this.ProductsService.getBrandList(SearchText).subscribe({
			next: (res: any) => (this.brandList = res.result),
			complete: () => {
				this.getController('brandId')?.setValue(
					this.promocodeDetails?.brand?.id
				)

				this.selectedBrand = this.promocodeDetails?.brand
			},
		})
	}

	getController(controlName: string) {
		return this.productPromoCodeForm.controls[controlName]
	}

	skipLetterE(event: any) {
		if (event.key.toLowerCase() === 'e') {
			event.preventDefault()
		}
	}

	checkLength(controller: string, input: any, maxLength: number) {
		this.getController(controller).setValue(
			input.target.value.slice(0, maxLength)
		)
	}

	getSelectedProductNames() {
		this.selectedProductNames = this.promoCodeProductList?.filter((obj) => {
			return this.getController('productVariantIds')?.value?.includes(
				obj?.variantId
			)
		})

		this.checkOverlapLabel()
	}
	checkOverlapLabel() {
		let labelCheck = this.selectedProductNames?.filter((prod: any) => {
			return prod.hasLabel && prod?.promoCodeId != this?.id
		})

		labelCheck?.length > 0 && this.getController('showLabel').value
			? (this.labelOverlapError = true)
			: (this.labelOverlapError = false)
	}
	removeProduct(product: any) {
		let products = this.getController('productVariantIds').value
		let filteredProducts = products.filter((ele: any) => {
			return ele !== product.variantId
		})
		this.getController('productVariantIds').setValue(filteredProducts)

		this.getSelectedProductNames()
		this.checkAllSelected()
	}
	changePromoCodeType(offerType: number) {
		if (offerType == 1) {
			this.getController('promocodeAmount')?.value
				? this.getController('promocodeAmount').reset()
				: null
			this.productPromoCodeForm?.addControl(
				'promocodeAmount',
				new FormControl('', [Validators.required, Validators.min(1)])
			)
			this.productPromoCodeForm?.addControl(
				'fixedDiscountMinimum',
				new FormControl('', [Validators.min(1)])
			)
			this.getController('percentageUpto')
				? this.productPromoCodeForm?.removeControl('percentageUpto')
				: null
			this.getController('offerBuyCount')
				? this.productPromoCodeForm?.removeControl('offerBuyCount')
				: null
			this.getController('offerGetCount')
				? this.productPromoCodeForm?.removeControl('offerGetCount')
				: null
		} else if (offerType == 2) {
			this.getController('promocodeAmount')?.value
				? this.getController('promocodeAmount').reset()
				: null
			this.productPromoCodeForm?.addControl(
				'promocodeAmount',
				new FormControl('', [Validators.required, Validators.min(1)])
			)
			this.productPromoCodeForm?.addControl(
				'percentageUpto',
				new FormControl('', [Validators.required, Validators.min(1)])
			)
			this.getController('offerBuyCount')
				? this.productPromoCodeForm?.removeControl('offerBuyCount')
				: null
			this.getController('fixedDiscountMinimum')
				? this.productPromoCodeForm?.removeControl('fixedDiscountMinimum')
				: null
			this.getController('offerGetCount')
				? this.productPromoCodeForm?.removeControl('offerGetCount')
				: null
		} else {
			this.getController('percentageUpto')
				? this.productPromoCodeForm?.removeControl('percentageUpto')
				: null
			this.getController('fixedDiscountMinimum')
				? this.productPromoCodeForm?.removeControl('fixedDiscountMinimum')
				: null
			this.getController('promocodeAmount')
				? this.productPromoCodeForm?.removeControl('promocodeAmount')
				: null
			this.productPromoCodeForm?.addControl(
				'offerBuyCount',
				new FormControl('', [Validators.required, Validators.min(1)])
			)
			this.productPromoCodeForm?.addControl(
				'offerGetCount',
				new FormControl('', [Validators.required, Validators.min(1)])
			)
		}
		this.checkUnique(this.getController('code').value)
	}
	promocodeAmountValidator() {
		if (
			this.getController('promocodeAmount')?.value &&
			this.getController('fixedDiscountMinimum')?.value
		) {
			if (
				Number(this.getController('promocodeAmount')?.value) >=
				Number(this.getController('fixedDiscountMinimum')?.value)
			) {
				this.getController('promocodeAmount').setErrors({
					amountExceedMinimum: true,
				})
			} else {
				delete this.getController('promocodeAmount').errors?.amountExceedMinimum
				const errors = this.getController('promocodeAmount').errors
				const length = errors ? Object.keys(errors).length : 0
				length
					? this.getController('promocodeAmount').setErrors(errors)
					: this.getController('promocodeAmount').setErrors(null)
			}
		} else {
			delete this.getController('promocodeAmount').errors?.amountExceedMinimum
			const errors = this.getController('promocodeAmount').errors
			const length = errors ? Object.keys(errors).length : 0
			length
				? this.getController('promocodeAmount').setErrors(errors)
				: this.getController('promocodeAmount').setErrors(null)
		}
	}
	promocodePercentageValidator() {
		if (this.getController('promocodeAmount')?.value) {
			if (Number(this.getController('promocodeAmount')?.value) > Number(100)) {
				this.getController('promocodeAmount').setErrors({
					percentageCantExceedHundred: true,
				})
			} else {
				delete this.getController('promocodeAmount').errors
					?.percentageCantExceedHundred
				const errors = this.getController('promocodeAmount').errors
				const length = errors ? Object.keys(errors).length : 0
				length
					? this.getController('promocodeAmount').setErrors(errors)
					: this.getController('promocodeAmount').setErrors(null)
			}
		}
	}
	clientUsageValidator() {
		if (
			this.getController('clientUsageCount')?.value &&
			this.getController('maxUsageCount')?.value
		) {
			Number(this.getController('clientUsageCount')?.value) >
			Number(this.getController('maxUsageCount')?.value)
				? this.getController('clientUsageCount').setErrors({
						clientUsageExceedTotalmaxUsageCount: true,
				  })
				: delete this.getController('clientUsageCount').errors
						?.clientUsageExceedTotalmaxUsageCount
			const errors: any = this.getController('clientUsageCount').errors
			errors
				? Object.keys(errors)?.length == 0
					? this.getController('clientUsageCount').setErrors(null)
					: null
				: null
		}
	}

	getFilteredProducts(firstLoad: boolean) {
		if (firstLoad) {
			this.promoCodeFilter.categoryId = this.promocodeDetails?.category?.id
			this.promoCodeFilter.subCategoryId =
				this.promocodeDetails?.subCategory?.id
			this.promoCodeFilter.subSubCategoryId =
				this.promocodeDetails?.subSubCategory?.id
			this.promoCodeFilter.brandId = this.promocodeDetails?.brand?.id
		}
		this.promoCodeFilter.startDate = this.getController('startDate').value
		this.promoCodeFilter.endDate = this.getController('endDate').value
		this.ProductsService.getFilteredProducts(this.promoCodeFilter).subscribe({
			next: (res: any) => {
				this.promoCodeProductList = res.result
			},
			complete: () => {
				if (firstLoad) {
					this.getController('productVariantIds').setValue(
						this.promocodeDetails.productName.map((ele: any) => ele.id)
					)
					this.selectedProductNames = this.promoCodeProductList.filter(
						(mainListProduct: any) => {
							return this.promocodeDetails.productName.some(
								(promoCodeProduct: any) => {
									return mainListProduct?.variantId === promoCodeProduct?.id
								}
							)
						}
					)
				}
			},
		})
	}
	checkProductsStartEndDate() {
		if (
			this.getController('startDate').value &&
			this.getController('endDate').value
		) {
			this.getFilteredProducts(false)
			this.hideProductSearch = false
		} else {
			this.promoCodeProductList = []
			this.hideProductSearch = true
		}
		this.getSelectedProductNames()
	}
	targetAudienceChange(event: any) {
		if (event?.checked) {
			!this.getController('gender').value
				? this.getController('gender').setValue([])
				: null
			this.getController('gender').setValue([
				...this.getController('gender').value,
				event.source.value,
			])
		} else {
			let objIndex = [...this.getController('gender').value]?.indexOf(
				event.source.value
			)
			let newArray = this.getController('gender').value
			newArray.splice(objIndex, 1)
			this.getController('gender').setValue(newArray)
		}
	}
	checkUnique(event: any) {
		let keyword = event?.target?.value ? event?.target?.value : event
		if (keyword.length > 0) {
			this.subscription.add(
				this.ProductsService.checkCodeUnique(keyword, this.id).subscribe(
					(res: any) => {
						res.result
							? this.productPromoCodeForm
									.get('code')
									?.setErrors({ unique: res.result })
							: this.productPromoCodeForm.get('code')?.setErrors(null)
						keyword.length <= 0
							? this.productPromoCodeForm
									.get('code')
									?.setErrors({ required: true })
							: null
					}
				)
			)
		} else {
			this.productPromoCodeForm.get('code')?.setErrors({ required: true })
		}
	}
	save() {
		let formRawValues = this.productPromoCodeForm.getRawValue()
		this.promoCodeFilter.searchText.length > 0
			? (this.allSelectedFlag = false)
			: null
		let body: createPromoCodePayload = {
			id: this.id,
			offerNameAr: formRawValues?.offerNameAr,
			offerNameEn: formRawValues?.offerNameEn,
			offerImageEn: formRawValues?.offerImageEn,
			offerImageAr: formRawValues?.offerImageAr,
			code: formRawValues.code,
			startDate: formRawValues.startDate,
			endDate: formRawValues.endDate,
			clientUsageCount: formRawValues.clientUsageCount,
			maxUsageCount: formRawValues.maxUsageCount,
			isActive: formRawValues.isActive,
			numberOfSameProduct: formRawValues.numberOfSameProduct,
			promoCodeType: formRawValues.promoCodeType,
			promoCodeAmount: formRawValues.promocodeAmount,
			fixedDiscountMinimum: formRawValues.fixedDiscountMinimum,
			percentageUpto: formRawValues.percentageUpto,
			offerBuyCount: formRawValues.offerBuyCount,
			offerGetCount: formRawValues.offerGetCount,
			hasLabel: formRawValues.showLabel,
			selectAll: this.allSelectedFlag,
			countryId: this.promoCodeFilter.countryId,
			gender: formRawValues.gender,
			filter: {
				categoryId: formRawValues.categoryId,
				subCategoryId: formRawValues.subCategoryId,
				subSubCategoryId: formRawValues.subSubcategoryId,
				brandId: formRawValues.brandId,
				countryId: this.promoCodeFilter.countryId,
				gender: formRawValues.gender,
				startDate: formRawValues.startDate,
				endDate: formRawValues.endDate,
			},
			productVariantIds: this.allSelectedFlag
				? []
				: formRawValues.productVariantIds.filter(
						(product: number) => product !== 0
				  ),
		}
		this.subscription.add(
			this.ProductsService.editPromoCode(body).subscribe((res) => {
				this.toaster.success(
					this.translate.instant('TOASTER.EDITED_SUCCESSFULLY')
				)
				this.changeEditMode.emit(false)
			})
		)
	}
	uploadImage(imageName: string) {
		this.dialog
			.open(UploadImageComponent, {
				width: '752px',

				panelClass: ['overflow-y-auto'],
				data: this.imgConfig,
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						const body = new FormData()
						body.append('image', res.selectedFile)
						this.subscription.add(
							this.offerService.UploadOfferImage(body).subscribe((res: any) => {
								imageName == 'ar'
									? this.getController('offerImageAr')?.setValue(
											res?.result?.url
									  )
									: this.getController('offerImageEn')?.setValue(
											res?.result?.url
									  )
							})
						)
					}
				},
			})
	}
	cancel() {
		this.changeEditMode.emit(false)
	}
	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
